interface Window {
  ga: Function;
}

declare const window: Window

class GA {
  tracker: Function

  constructor(tracker: Function) {
    this.tracker = tracker
  }

  trackEvent(category = '', action = '', label = '') {
    if (!this.tracker) return

    this.tracker('send', 'event', category, action, label)
  }
}

export default new GA(window.ga)
